import { FirebaseData } from "../General/FirebaseData";
import { UserData } from "../User/UserData";
import { LocalData } from "../General/LocalData";

export class EventAttendeeData extends FirebaseData {
  user?: UserData;
  attendingCount = 0;

  setup(data: any): void {
    this.user = typeof data.userID === "string" ? LocalData.users.addData(data.userID) : undefined;

    if (this.isValidNumber(data.attendingCount)) {
      this.attendingCount = data.attendingCount;
    }
  }
}
